<template>
  <div id="widget" v-show="show">
    <div class="icon">
      <router-link to="/pages/message">
        <img src="../assets/images/icon-message.png" />
        <p>{{ getTitle('widget.Message') }}</p>
      </router-link>
    </div>
    <div class="qrcode">
      <img src="../assets/images/qrcode.png" />
      <p>{{ getTitle('widget.Wechat') }}</p>
    </div>
    <div class="qrcode">
      <img src="../assets/images/qrcode.png" />
      <p>{{ getTitle('widget.APP') }}</p>
    </div>
    <div class="tel">
      {{ getTitle('widget.Counseling') }}
      <p>0433-6688330</p>
    </div>
    <div class="tel">
      {{ getTitle('widget.Complaint') }}
      <p>0433-6686315</p>
    </div>
    <div class="tel">
      {{ getTitle('widget.Rescue') }}
      <p>0433-6686120</p>
    </div>
    <div class="close" @click="hiddenShow()">
      {{ getTitle('widget.Close') }}
    </div>
  </div>
</template>

<script>
import www from '../api/www';
import _ from 'underscore';
import { setLocaleToPath, loadLanguageAsync } from '@/setup/i18n';
export default {
  data() {
    return {
      show: true,
    };
  },
  computed: {
    locale() {
      return this.$store.state.locale;
    },
  },
  created() {
    this.$store.commit('setLocale', this.$i18n.locale); // 触发指定默认语言
  },
  methods: {
    getTitle(name) {
      loadLanguageAsync(this.locale);
      return this.$t(`${name}.title`);
    },
    hiddenShow() {
      this.$nextTick(() => {
        this.show = false;
      });

      // let that = this;
      // that.show = false;
    },
    go(url) {
      window.open(url, '_blank');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
#widget {
  width: 90px;
  padding: 0 0 0;
  position: fixed;
  top: 50%;
  right: 20px;
  z-index: 999;
  border-radius: 8px;
  color: #000;
  text-align: center;
  background: #fff;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  transform: translateY(-50%);
  .icon {
    padding: 10px 0;
    border-bottom: 1px solid #eee;
    img {
      width: 40px;
      height: 40px;
    }
    a {
      color: #000;
    }
  }
  .qrcode {
    padding: 12px 0;
    border-bottom: 1px solid #eee;
    img {
      width: 60px;
      height: 60px;
      margin-bottom: 2px;
    }
  }
  .tel {
    padding: 12px 0;
    border-bottom: 1px solid #eee;
    p {
      color: #31a775;
      font-size: 12px;
    }
  }
  .close {
    padding: 10px 0;
    border: none;
    border-radius: 0 0 8px 8px;
    color: #9e9e9e;
    background: #f8f8f8;
    cursor: pointer;
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  }
}
</style>
